export const militaryStatusOptions = [
  'ActiveDuty',
  'ActiveReserve',
  'InactiveReserve',
];

export const militaryStatusOptionsPvq = [
  'ActiveDuty',
  'ActiveReserve',
  'InactiveReserve',
  'Other',
  'RetiredReserve',
  'TraditionalReservist',
];
